export default `
# Connect to Slack!

---

`;



// WEBPACK FOOTER //
// ./src/pages/Bot/BotMd.js